var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NotifyClient } from '@juvare/platform-sdk-js/NotifyClient';
import { AlertBaseClient } from './AlertBaseClient';
/**
 * @deprecated - methods transferred to AlertServiceClient*/
class DocumentClient extends AlertBaseClient {
    constructor(baseUrl) {
        const notifyClient = new NotifyClient();
        super({ onTokenRequest: () => notifyClient.getAlertToken().then((result) => result.token) }, baseUrl);
        this.saveDocuments = (documents) => __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            documents.forEach((fe) => formData.append('files', fe));
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/v1/documents/',
                data: formData,
            });
            return response.data;
        });
        this.getDocument = (id) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/v1/documents/' + id,
                responseType: 'blob',
            });
            return response.data;
        });
        this.updateDocumentsScanResult = (ids) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: '/v1/documents',
                data: { ids: ids },
            });
            return response.data;
        });
    }
}
export default DocumentClient;
